{
    "TeamsAuth_UserIntro": "Hallo **{}**,",
    "TeamsAuth_UserIntro_2": "Akixi für MS Teams bittet um Zugriff auf Ihren Microsoft Entra Tenant",
    "TeamsAuth_AdminConsent": "Erteilung der Zustimmung der Verwaltung",
    "TeamsAuth_Authorise": "Autorisieren Sie",
    "TeamsAuth_ConsentedMessage": "Admin Consent erteilt, bitte klicken Sie auf Authorise um fortzufahren",
    "TeamsAuth_AuthorisedMessage": "Bewilligung erteilt",
    "TeamsAuth_Decline": "Rückgang",
    "TeamsAuth_Error_Unknown": "Es ist ein nicht erkannter Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Systemadministrator.",
    "NAME": "TeamsAuth",
    "TeamsAuth_Authoriser_Select_Title": "Welche Benutzer möchten Sie aus Ihrem Microsoft Entra-Mandanten synchronisieren?",
    "TeamsAuth_Authoriser_Select_Options_Tenant": "Alle relevanten Benutzer des Mandanten",
    "TeamsAuth_Authoriser_Select_Options_SecurityGroups": "Nur ausgewählte Sicherheitsgruppen",
    "TeamsAuth_SecurityGroups_Loader_Title_1": "Sicherheitsgruppen einrichten",
    "TeamsAuth_SecurityGroups_Loader_Title_2": "Das sollte nicht lange dauern, bitte haben Sie etwas Geduld...",
    "TeamsAuth_SecurityGroups_Title": "Bitte wählen Sie Ihre Sicherheitsgruppen aus.",
    "TeamsAuth_SecurityGroups_SecurityGroup_NothingToSee": "Es wurden keine Sicherheitsgruppen gefunden...",
    "TeamsAuth_SecurityGroups_SecurityGroup": "[AUSWEIS: {}]",
    "TeamsAuth_SecurityGroups_Note": "Hinweis: Sicherheitsgruppen können später aktualisiert werden.",
    "TeamsAuth_SecurityGroups_SyncAndClose": "Synchronisieren und Schließen",
    "TeamsAuth_SecurityGroups_NoSecurityGroups": "Den gesamten Mandanten synchronisieren"
}